import Component from 'navigation/component/Component';
import scroll from 'core/scroll';
class BlueshiftPopin extends Component {
    observer;
    constructor(el, options) {
        const w = window;
        super(el, options);
        if (w.blueshift)
            w.blueshift.live();
        this.bindRefs();
    }
    bindRefs() {
        super.bindRefs(...arguments);
    }
    bindEvents(add = true) {
        const method = add ? 'addEventListener' : 'removeEventListener';
        this.mutationObserver(add);
        this.refs.overlayPanel[method]('click', this.close);
        if (this.refs.popinInner?.innerHTML?.length)
            setTimeout(() => this.open(), 400);
    }
    mutationObserver(add = true) {
        const callback = (mutationList) => {
            for (const mutation of mutationList)
                if (mutation.type === 'childList')
                    this.onPopinUpdate(mutation);
        };
        this.observer = new MutationObserver(callback);
        this.observer.observe(this.el, {
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    open = () => {
        this.el.classList.add('opened');
        scroll.lock(true);
    };
    close = () => {
        this.el.classList.remove('opened');
        scroll.unlock(true);
        this.observer.disconnect();
    };
    onPopinUpdate = (mutation) => {
        const notEmpty = mutation.addedNodes.length > 0;
        if (notEmpty)
            this.open();
        else
            this.close();
    };
}
export default BlueshiftPopin;
